export const nuvemshop = {
  typeAnimationFeatures: [
    { title: "Soporte 24/7" },
    { title: "Automatización Inteligente" },
    { title: "Marketing Visual" },
    { title: "WhatsApp Business" },
  ],
  hero: {
    title: "Revolucioná tu E-commerce con Inteligencia Artificial",
    subtitle:
      "El Hub de IA de Araria trae el poder de la inteligencia artificial a tu tienda Nuvem Shop, con agentes inteligentes de atención al cliente, automatización y herramientas avanzadas de marketing.",
    cta: {
      primary: "Instalar Ahora",
      secondary: "Ver Cómo Funciona",
    },
  },
  mainFeatures: {
    title: "Transformá tu Operación de E-commerce",
    subtitle: "Potenciá tus ventas con funciones avanzadas de IA",
  },
  features: {
    support24: {
      title: "Soporte Automatizado 24/7",
      description:
        "Ofrecé soporte instantáneo a tus clientes con agentes de IA personalizados que funcionan en tu sitio web y vía WhatsApp, incluso cuando no estás disponible.",
    },
    automation: {
      title: "Automatización Inteligente",
      description:
        "Reducí horas de trabajo manual con la asistente virtual Ária, que accede a datos, crea productos y gestiona promociones directamente desde el panel.",
    },
    marketing: {
      title: "Marketing Visual Potente",
      description:
        "Creá videos promocionales profesionales en minutos con nuestra herramienta de generación de videos por IA, sin necesidad de un equipo especializado.",
    },
    integration: {
      title: "Integración Perfecta",
      description:
        "Todas las herramientas de IA de Araria se integran nativamente con tu tienda Nuvem Shop, sin necesidad de configuraciones técnicas complejas.",
    },
  },
  agents: {
    title: "Agentes de IA: Soporte Inteligente para tu Tienda",
    subtitle:
      "Transformá la atención al cliente de tu tienda con agentes de IA personalizados que conocen tus productos, políticas y responden consultas las 24 horas del día, los 7 días de la semana.",
  },
  agent: {
    features: {
      knowledge: {
        title: "Base de Conocimiento Personalizada",
        description:
          "Alimentá tu agente con información específica sobre tus productos, políticas de cambio, tiempos de entrega y preguntas frecuentes",
      },
      channels: {
        title: "Múltiples Canales de Atención",
        description:
          "Disponibilizá el mismo agente en tu sitio web y vía WhatsApp",
      },
      personality: {
        title: "Personalidad Ajustable",
        description:
          "Configurá el tono de comunicación de tu agente para reflejar la identidad de tu marca",
      },
      analytics: {
        title: "Análisis de Rendimiento",
        description:
          "Seguí métricas de atención y satisfacción de los clientes",
      },
    },
  },
  whatsapp: {
    title: "Soporte de WhatsApp con Inteligencia Artificial",
    subtitle:
      "Llevá tu atención donde están tus clientes. Los agentes de Araria funcionan perfectamente en WhatsApp, permitiéndote automatizar tanto campañas promocionales como soporte al cliente.",
    features: {
      instant: {
        title: "Soporte Instantáneo",
        description:
          "Respuestas inmediatas 24/7 en el canal preferido de los consumidores",
      },
      recovery: {
        title: "Recuperación de Carritos",
        description:
          "Recordá a los clientes sobre productos abandonados en el carrito",
      },
      campaigns: {
        title: "Campañas Promocionales",
        description: "Enviá ofertas personalizadas a clientes segmentados",
      },
      tracking: {
        title: "Seguimiento de Pedidos",
        description:
          "Actualizá automáticamente a los clientes sobre el estado de entrega",
      },
    },
  },
  aria: {
    title: "Conocé a Ária: Tu Asistente Virtual Especializada en E-commerce",
    subtitle:
      "Ária no es un simple chatbot. Es una asistente inteligente específicamente desarrollada para la gestión de e-commerce, integrada en el entorno administrativo de tu tienda Nuvem Shop.",
    features: {
      products: {
        title: "Gestión de Productos",
        description: "Creá y actualizá productos con asistencia inteligente",
      },
      promotions: {
        title: "Gestión de Promociones",
        description: "Gestioná promociones y cupones de descuento fácilmente",
      },
      tools: {
        title: "Herramientas Avanzadas",
        description:
          "Accedé a herramientas de optimización y análisis de la tienda",
      },
    },
  },
  videoCreator: {
    title: "Transformá Fotos en Videos Profesionales en Minutos",
    subtitle:
      "Nuestra herramienta de creación de videos por IA transforma las fotos de tu catálogo en contenido publicitario profesional para tus redes sociales y campañas de marketing.",
    features: {
      creation: {
        title: "Creación Automática",
        description: "Transformá fotos en videos profesionales automáticamente",
      },
      customization: {
        title: "Personalización Total",
        description: "Agregá tu marca, música y elementos visuales",
      },
      sharing: {
        title: "Compartir Fácil",
        description: "Publicá directamente en redes sociales",
      },
    },
  },
  cta: {
    title: "Comenzá a Transformar tu E-commerce Hoy",
    subtitle:
      "Instalá el Hub de IA de Araria y llevá tu tienda Nuvem Shop al siguiente nivel",
    button: "Instalar Gratis",
  },
};
